import { PropertyGroup } from '@features/product/typings';

export default function filterSpecifications(
  search: string,
  propertyGroups: PropertyGroup[]
): PropertyGroup[] {
  const searchValue = search.trim().toLowerCase();

  if (!searchValue) return propertyGroups;

  return propertyGroups
    .map(propertyGroup => ({
      title: propertyGroup.title,
      properties: propertyGroup.properties.filter(
        property =>
          (property.displayName?.trim().toLowerCase().includes(searchValue) ?? false) ||
          (property.value?.trim().toLowerCase().includes(searchValue) ?? false)
      )
    }))
    .filter(propertyGroup => propertyGroup.properties.length > 0);
}
